<div class="row">
    <p class="error">{{error_message}}</p>
  </div>
  <div *ngIf="loading" class="overlay">
    <div class="spinner"></div>
  </div>

<!-- Modal -->
<div class="modal-backdrop" *ngIf="showFinalStepMessage">
  <div class="modal-content">
    <button class="close-btn" (click)="showFinalStepMessage = false">×</button>
    <span class="icon">!</span>
    <div class="text">
      <h4>Almost there!</h4>
      <p>In this final step, please download, sign, and upload the two required policy documents.</p>
    </div>
  </div>
</div>

<blockquote>
    <h5 class="headings">SIGN & UPLOAD</h5>
</blockquote>

<form>
    <div *ngIf="!isViewOnly">
      <h6 class="instructions">
        Please carefully read the following documents and confirm your acceptance as final by signing and uploading.
      </h6>

      <div class="terms-section">
        <!-- Column 1 -->
        <div class="terms-column">
          <a
            href="assets/docs/UNIPET_PROCUREMENT_TERMS&CONDITIONS.pdf"
            target="_blank"
            class="terms-link"
            rel="noopener noreferrer"
            aria-label="Read the General Terms and Conditions of UNIPET (opens in a new tab)"
          >
            General Terms and Conditions of UNIPET
            <i class="fas fa-external-link-alt" aria-hidden="true"></i>
          </a>

          <div class="upload-group">
            <label class="custom-file-upload">
              <input #tcFileInput type="file" (change)="onFileSelected($event, 'tcFile')">
              Upload T&C File
            </label>
            <span class="file-info">PDF only. Upload to replace an existing file.</span>

            <div *ngIf="documents.tcFile || documents.tcFilePath" class="uploaded-file">
              <i class="tiny icon-inline material-icons">insert_drive_file</i>
              <span *ngIf="documents.tcFile">{{ documents.tcFile.name }}</span>
              <span *ngIf="!documents.tcFile && documents.tcFilePath">
                <a [href]="'data:application/pdf;base64,' + documents.tcFileData" [download]="documents.tcFilePath" target="_blank">
                  {{ documents.tcFilePath }}
                </a>
              </span>
              <button type="button" class="remove" (click)="removeDocument('tcFile', tcFileInput)" aria-label="Remove T&C file">×</button>
            </div>
          </div>
        </div>

        <!-- Column 2 -->
        <div class="terms-column">
          <a
            href="assets/docs/Supplier_Code_of _Conduct_and_Ethics.pdf"
            target="_blank"
            class="terms-link"
            rel="noopener noreferrer"
            aria-label="Read the SUPPLIER CODE OF CONDUCT AND ETHICS (opens in a new tab)"
          >
            Supplier Code of Conduct and Ethics
            <i class="fas fa-external-link-alt" aria-hidden="true"></i>
          </a>

          <div class="upload-group">
            <label class="custom-file-upload">
              <input #conductFileInput type="file" (change)="onFileSelected($event, 'conductFile')">
              Upload Conduct File
            </label>
            <span class="file-info">PDF only. Upload to replace an existing file.</span>

            <div *ngIf="documents.conductFile || documents.conductFilePath" class="uploaded-file">
              <i class="tiny icon-inline material-icons">insert_drive_file</i>
              <span *ngIf="documents.conductFile">{{ documents.conductFile.name }}</span>
              <span *ngIf="!documents.conductFile && documents.conductFilePath">
                <a [href]="'data:application/pdf;base64,' + documents.conductFileData" [download]="documents.conductFilePath" target="_blank">
                  {{ documents.conductFilePath }}
                </a>
              </span>
              <button type="button" class="remove" (click)="removeDocument('conductFile', conductFileInput)" aria-label="Remove Code of Conduct file">×</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!isViewOnly" class="consent-card">
      <div class="consent-row">
        <input
          id="vendorDataConsent"
          type="checkbox"
          name="vendorDataConsent"
          [ngModel]="vendorDataConsentAccepted"
          (ngModelChange)="onVendorConsentChange($event)"
          required
        />
        <label class="consent-label" for="vendorDataConsent">
          I have read, understood, and agree to be bound by the Terms and Conditions, and any other applicable policies governing the use of this portal. By checking this box and proceeding, I acknowledge and accept all such terms and conditions.
        </label>
      </div>
    </div>

  
    <!--Display uploaded signed documents in view only-->
    <div *ngIf="isViewOnly">
      <div *ngIf="documents.tcFileData && documents.tcFilePath">
        <p>
          Signed T&C File: 
          <a 
            [href]="'data:application/pdf;base64,' + documents.tcFileData" 
            [download]="documents.tcFilePath" 
            target="_blank"
            rel="noopener noreferrer"
            style="color: #079AFE;"
            >
            {{ documents.tcFilePath }}
          </a>
        </p>
      </div>
      <div *ngIf="documents.conductFileData && documents.conductFilePath">
        <p>
          Signed Conduct File: 
          <a 
            [href]="'data:application/pdf;base64,' + documents.conductFileData" 
            [download]="documents.conductFilePath" 
            target="_blank"
            rel="noopener noreferrer"
            style="color: #079AFE;"
            >
            {{ documents.conductFilePath }}
          </a>
        </p>
      </div>
    </div>
  
    <!-- <p *ngIf="!isViewOnly">
      <label>
        <input type="checkbox" name="agreement" [(ngModel)]="agreed" (ngModelChange)="resetErrorMessage()" />
        <span>
          I have read and agree to the
          <a
            href="/terms-and-conditions"
            target="_blank"
            class="terms-link"
            aria-label="Read the Terms and Conditions (opens in a new tab)"
          >
            Terms and Conditions
          </a>.
        </span>
      </label>
    </p> -->
</form>

<br *ngIf="isViewOnly && (vendorConsentRecord || vendorConsentAbsent)">

<blockquote *ngIf="isViewOnly && (vendorConsentRecord || vendorConsentAbsent)">
    <h5 class="headings">DATA PROCESSING CONSENT</h5>
</blockquote>

<form *ngIf="isViewOnly && vendorConsentRecord as consent">
    <h6 class="instructions vendor-consent-written-intro">
        On {{ consent.acceptedAt | date:'dd MMMM yyyy, h:mm a' }},
        <strong>{{ user.strName }}</strong>
        of <strong>{{ company.strCompanyName }}</strong>
        confirmed their acceptance of the Terms and Conditions by checking the consent box on this portal.
    </h6>
</form>

<form *ngIf="isViewOnly && vendorConsentAbsent">
    <h6 class="instructions vendor-consent-absent">
        This registration was submitted before the data processing consent requirement was introduced.
        No consent record is on file for this vendor account. 
    </h6>
</form>

<br>

<blockquote>
    <h5 class="headings">PRINCIPLES OF CONDUCT</h5>
</blockquote>

<form>
    <h6 class="instructions">
        All Vendors seeking to work with UNIPET shall respect and adhere to the following principles:
        <br>
        <br>
        <div style="padding-left: 20px;">
            <b>1. Business Ethics: </b>
            Vendors and subcontractors are expected to maintain the highest degree of business ethics when working with UNIPET. Vendors and subcontractors must comply with the labor laws and standards of Trinidad and Tobago (e.g. compliance with minimum wage requirement) unless otherwise stated and agreed upon by both parties.
            <br>
            <br>

            <b>2. Transparency of information provision:</b>
            Vendors shall not be involved in any fraudulent activities, misrepresent information or facts for the purpose of influencing the selection and contract awarding process in their favor.
            <br>
            <br>


            <b>3. Fair Competition:</b>
            Vendors shall not be involved in any corrupt, collusive, or coercive practices.
            <br>
            <br>

            <b>4. Human Rights: </b>
            Vendors shall not engage in any forced or underage labor in any form.
            <br>
            Vendors shall provide a safe and healthy workplace environment for all its employees and comply with the Occupational Safety and Health Act of Trinidad and Tobago and all international laws, where applicable.
            <br>
            <br>


            <b>5. Environment: </b>
            All vendors should undertake a precautionary approach to environmental concerns.
            <br>
            Where applicable, vendors should undertake initiatives to promote greater environmental responsibility.
            <br>
            <br>
        </div>

        If at any time during the registration or procurement process UNIPET determines that the Vendor is in violation of the abovementioned principles, that Vendor’s request for registration or bid may be declined as ineligible.
        <br>
        <br>
        The respect of fundamental human rights and labor standards is stipulated in the General Terms and Conditions and must be accepted by you as a condition of contracting with UNIPET. Any refusal of these terms shall constitute grounds for rejection of Vendor’s registration request or bid; and any violation during contract terms shall constitute grounds for termination.

    </h6>
</form>
  
<br>
<br>
<blockquote>
    <h5 class="headings">DECLARATION</h5>
</blockquote>
<form>
    <h6 class="instructions">
        The undersigned, an authorized signatory for the company, hereby certifies that the information provided herein, including that or any attached pages is true and correct to the best of his/her knowledge.
        <br>
        <br>
        <span *ngIf="!isViewOnly"  style="font-weight: 800;">I/WE DECLARE THAT THE INFORMATION GIVEN IS ACCURATE.</span>
        <span *ngIf="isViewOnly"  style="font-weight: 800;">THE FOLLOWING PERSON HAS DECLARED THAT THE INFORMATION GIVEN IS ACCURATE.</span>
    </h6>
    <div *ngIf="isViewOnly">
        <h6 style="font-size: large; font-weight: 400; font-style: italic; color: rgb(71, 138, 237);">
            <a href="/profile" target="_blank">{{user.strName}}</a> of {{company.strCompanyName}}, 
            <h4 style="font-size: medium; font-weight: 300;">
                {{ user.dteCreated }}
            </h4>
            <!-- SIGNATURE IMAGE HERE-->
            <img *ngIf="isViewOnly && (user?.signatureFileData || user?.signatureData)"
            [src]="'data:image/png;base64,' + (user?.signatureFileData || user?.signatureData)"
            alt="User Signature"
            style="max-width: 200px; border: 1px solid #ccc;" />
        </h6>
    </div>
    <br>
    <br>


    <label *ngIf="!isViewOnly" class="file-info">The name here is the same as the contact person entered at the beginning of the form.</label><br>
    <div *ngIf="!isViewOnly" class="input-row">
        <select style="display: block;" id="title" name="title" required [(ngModel)]="user.strTitle" (ngModelChange)="onTitleChange($event)">
            <option value="" disabled selected>Select a title</option>
            <option *ngFor="let title of titles" [value]="title">{{ title }}</option>
        </select>
        <input type="text" name="user-name" placeholder="Name" [(ngModel)]="user.strName" (ngModelChange)="resetErrorMessage()"> 
        <input type="date" name="signature-date" placeholder="Date" [(ngModel)]="currentDate" disabled>
    </div>
    
    <br>
    <app-signature-pad *ngIf="!isViewOnly" (ngModelChange)="resetErrorMessage()" (signatureSaved)="updateSignature_fromPad($event)"></app-signature-pad>
    <br>

    <label *ngIf="!isViewOnly" class="file-info">File type must be PNG or JPG. Upload new file to replace an existing upload.</label><br><br>
    <label *ngIf="!isViewOnly" class="custom-file-upload">
        Upload Signature
        <i class="tiny icon-inline material-icons">file_upload</i>
        <input type="file" (change)="onImgSelected($event)" (ngModelChange)="resetErrorMessage()">
    </label>
    <p *ngIf="!isViewOnly && user?.signatureFile" style="color: #E65F53;"> 
        <i class="tiny icon-inline material-icons">insert_photo</i>
        {{ user.signatureFile.name }}
    </p>
   
    <br>
    <br>
    <br>

</form>